import { ListRender } from "../../shared/components/base/list/ListRender";
import { IPage } from "../../shared/components/definitions/page/IPage";
import { ConfirmModalRender } from "../../shared/components/implementations/modal/ConfirmModalRender";
import { RotacionPesajeVeterinariaDetailModalRender } from "../../shared/components/modulos/pesaje/ganaderia/modal/RotacionPesajeVeterinariaDetailModalRender";
import { RotacionPesajeVeterinariaListItemRender } from "../../shared/components/modulos/pesaje/ganaderia/list/RotacionPesajeVeterinariaListItemRender";
import { RotacionPesajeVeterinariaModalRender } from "../../shared/components/modulos/pesaje/ganaderia/modal/RotacionPesajeVeterinariaModalRender";
import { serviceProvider } from "../../shared/comun/provider/ServiceProvider";
import {
  fx_createRotacionPesajeVeterinariaRequest,
  fx_createRotacionPesajeVeterinariaRequestEmpty,
} from "../../shared/modulos/pesaje/ganaderia/request/RotacionPesajeVeterinariaRequest";
import { RotacionPesajeVeterinariaResponse } from "../../shared/modulos/pesaje/ganaderia/response/RotacionPesajeVeterinariaResponse";
import { RotacionPesajeVeterinariaDeleteGrpcService } from "../../shared/modulos/pesaje/ganaderia/services/RotacionPesajeVeterinariaDeleteGrpcService";
import { fx_createRotacionPesajeVeterinariaGrpcService } from "../../shared/modulos/pesaje/ganaderia/services/RotacionPesajeVeterinariaGrpcService";
import { formatFechaCorta } from "../../shared/utils/fechaUtils";

/** Página de eventos de Pesaje / Rotación / Veterinaria (pesaje · ganadería):
 *  sección + lista de eventos de la finca activa. (Alta/ver/editar en fases
 *  siguientes.) */
export class RotacionPesajeVeterinariaPage implements IPage {
  /** Lista de eventos (sección + filas). Se crea en `render` (ver nota). */
  private _list: ListRender<RotacionPesajeVeterinariaResponse> | null = null;

  /** Monta la sección/lista en el contenedor de la página.
   *  La lista se construye aquí (no en el constructor) porque `AppRender` llama
   *  `dispose()` de la página antes de `render()`; hacerlo en el constructor
   *  dejaría la lista disposed antes de cargar. */
  render(
    pageContent: HTMLDivElement,
    _secondSidebarWrapper: HTMLDivElement,
  ): void {
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    this._list = new ListRender<RotacionPesajeVeterinariaResponse>({
      label: "PESAJE · GANADERÍA",
      title: "Pesaje / Rotación / Veterinaria",
      subtitle: `${finca.nombreFinca} · Registro de eventos`,
      addLabel: "Nuevo evento",
      onAdd: () =>
        new RotacionPesajeVeterinariaModalRender(
          fx_createRotacionPesajeVeterinariaRequestEmpty(),
        ).init(),
      listService: fx_createRotacionPesajeVeterinariaGrpcService(
        finca.id,
      ),
      createItem: (evento) =>
        new RotacionPesajeVeterinariaListItemRender(evento, {
          onView: (e) =>
            new RotacionPesajeVeterinariaDetailModalRender(e).init(),
          onEdit: (e) =>
            new RotacionPesajeVeterinariaModalRender(
              fx_createRotacionPesajeVeterinariaRequest(e),
            ).init(),
          onDelete: (e) =>
            new ConfirmModalRender({
              title: "Eliminar evento",
              message: `¿Está seguro que desea eliminar el evento del <strong>${formatFechaCorta(e.fecha)}</strong> de <strong>${finca.nombreFinca}</strong>? Esta acción no se puede deshacer.`,
              onConfirm: async () => {
                await new RotacionPesajeVeterinariaDeleteGrpcService().deleteAsync(e);
                serviceProvider.getLayoutService().reload();
              },
            }).init(),
        }),
      emptyMessage: "Sin eventos registrados",
    });

    pageContent.innerHTML = this._list.render();
    this._list.connect();
  }

  /** Dispone la lista. */
  dispose(): void {
    this._list?.dispose();
    this._list = null;
  }
}
